import React, { Fragment, useEffect, useCallback, useState } from 'react'
import { Formik } from 'formik'
import { connect, useSelector } from 'react-redux'
import Input from '../Input'
import { Button, LinkButton } from '../header/elements'
import validation from './validations/register'
import { retrieveFusionErrorMessage } from '../../utils/helpers'
import { BeatLoader } from 'react-spinners'
import register, {
    clearregisterUserBoundActionCreator,
} from './Register.action'
import { AuthenticationContainer } from './elements'
import { ReactComponent as GoogleLogo } from '../../assets/googleLogo.svg'
import { Text } from '../sendflow/styles/elements'
import { useGoogleAuth } from './hooks/useGoogleLogin'
import { useHistory, useLocation } from 'react-router-dom'
import useQuery from './hooks/useQuery'

const Registeration = (props) => {
    const location = useLocation()
    const params = new URLSearchParams(location?.search)
    const passedEmail = params.get('email')
    const initialState = {
        email: props.email || passedEmail || '',
        password: '',
    }
    const query = useQuery()
    const history = useHistory()
    const [referrer, setReferrer] = useState('')
    const { register, user } = useSelector((state) => state)
    const { fetching, error } = register
    const { signIn } = useGoogleAuth()

    const getEmailError = useCallback(() => {
        return retrieveFusionErrorMessage(error, 'user.email')
    }, [error])

    const getPasswordError = useCallback(() => {
        return retrieveFusionErrorMessage(error, 'user.password')
    }, [error])

    const emailError = getEmailError()
    const passwordError = getPasswordError()

    const { clearError, isSuccessPage } = props

    const onVerify = useCallback(
        (email) => {
            history.push({
                pathname: `/verify`,
                state: {
                    email,
                },
            })
        },
        [history]
    )

    useEffect(() => {
        clearError()
    }, [clearError])

    const fetchUserDetails = () => {
        if (!user.resp.registration) {
            navigateToDashboard()
        }
    }

    const navigateToDashboard = () => {
        history.push('/create-username')
    }

    useEffect(() => {
        if (user.resp.token) {
            fetchUserDetails()
        }
        // eslint-disable-next-line
    }, [user.resp])

    const getReferrer = useCallback(() => {
        const referrer = query.get('referrer')
        setReferrer(referrer)
    }, [query])

    const handleGoogleAuthSignInWithReferrer = () => {
        try {
            signIn()
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getReferrer()
    }, [getReferrer])

    return (
        <Formik
            validationSchema={validation}
            initialValues={initialState}
            onSubmit={(values, actions) => {
                actions.setSubmitting(false)
                props.register(values, onVerify, referrer)
            }}
            render={(props) => {
                const onError =
                    props.errors.email ||
                    emailError ||
                    props.errors.password ||
                    passwordError

                const handleFormChange = (e) => {
                    clearError()
                    props.handleChange(e)
                }
                const onSubmit = (e) => {
                    // e.preventDefault()
                }
                const navigateToRegister = () => {
                    const params = new URLSearchParams()
                    params.append('email', props.values.email)
                    const url = `/register?${params.toString()}`
                    history.push(url)
                }
                return (
                    <Fragment>
                        <AuthenticationContainer onSubmit={onSubmit}>
                            {isSuccessPage ? (
                                <>
                                    <Text
                                        size={31}
                                        style={{
                                            marginBottom: 30,
                                            textAlign: 'center',
                                        }}
                                    >
                                        Want to track your transaction history
                                        on Coinprofile?
                                    </Text>
                                    <Input
                                        type="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={props.values.email}
                                        error={props.errors.email || emailError}
                                        onChange={handleFormChange}
                                    />
                                    <Button
                                        onClick={navigateToRegister}
                                        colored={true}
                                        free={true}
                                        wide={true}
                                        style={{
                                            marginTop: 10,
                                            cursor: 'pointer',
                                        }}
                                        disabled={onError}
                                        type="button"
                                    >
                                        {fetching ? (
                                            <BeatLoader color="#fff" size={5} />
                                        ) : (
                                            'Create account'
                                        )}
                                    </Button>
                                </>
                            ) : (
                                <>
                                    <Input
                                        type="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={props.values.email}
                                        error={props.errors.email || emailError}
                                        onChange={handleFormChange}
                                    />
                                    <Input
                                        type="password"
                                        name="password"
                                        placeholder="Enter password"
                                        value={props.values.password}
                                        error={
                                            props.errors.password ||
                                            passwordError
                                        }
                                        onChange={handleFormChange}
                                    />
                                    <Button
                                        colored={true}
                                        free={true}
                                        wide={true}
                                        style={{ marginTop: 10 }}
                                        disabled={onError}
                                        type="button"
                                        onClick={props.handleSubmit}
                                        data-cy="submitRegistrationData"
                                    >
                                        {fetching ? (
                                            <BeatLoader color="#fff" size={5} />
                                        ) : (
                                            'Create account'
                                        )}
                                    </Button>
                                    <hr className="horizontal-line" />
                                    <Button
                                        onClick={
                                            handleGoogleAuthSignInWithReferrer
                                        }
                                        outlined="true"
                                        free="true"
                                        wide="true"
                                        type="button"
                                    >
                                        <GoogleLogo />{' '}
                                        <span style={{ marginLeft: 8 }}>
                                            Sign up with Google
                                        </span>
                                    </Button>
                                </>
                            )}
                        </AuthenticationContainer>
                        {!isSuccessPage && (
                            <Text
                                size={23}
                                thickness={4}
                                as="div"
                                style={{
                                    fontSize: 16,
                                    width: '100%',
                                    display: 'flex',
                                    lineHeight: '20px',
                                    margin: '30px auto',
                                    textAlign: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                Already have an account?
                                <LinkButton
                                    to="/login"
                                    style={{
                                        margin: 0,
                                        marginLeft: 5,
                                        fontWeight: 400,
                                        width: 'fit-content',
                                        background: 'transparent',
                                    }}
                                    text="true"
                                    wide="true"
                                >
                                    Sign In
                                </LinkButton>
                            </Text>
                        )}
                    </Fragment>
                )
            }}
        />
    )
}
const mapDispatchToProps = {
    register,
    clearError: clearregisterUserBoundActionCreator,
}
export default connect(null, mapDispatchToProps)(Registeration)
